
import MobileProgramming from "../../../assets/duotone/MobileProgramming.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MobileProgrammingIcon({ className, dataTestid = "MobileProgrammingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MobileProgramming data-testid={dataTestid} className={classes} {...rest} />
  );
}
